// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"dc5a2df72407c9e7879e","147":"00dc8764e84cab1263ac","251":"fe193f95c1cb3b2160d6","352":"4454f4d2ca4ea4411d80","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};